import type { Resource } from '../../';
export const product_group_bigkids: Resource = {"default":"Big Kids'"};
